import { MetricName, ReliabilityMetrics } from '@canvas/frontend-metrics';

export type SocketRestartReason =
  | 'dropped_update'
  | 'confirm_mismatch'
  | 'ack_timeout'
  | 'lazy_sync_timeout'
  | 'backend_agent_operation_timeout';

export function recordSocketRestart({
  collabStrategyType,
  reason,
}: {
  collabStrategyType: string;
  reason: SocketRestartReason;
}) {
  const metricName = (() => {
    if (collabStrategyType === 'ncs') {
      switch (reason) {
        case 'dropped_update':
          return MetricName.SOCKET_RESTART_NCS_DROPPED_UPDATE;
        case 'confirm_mismatch':
          return MetricName.SOCKET_RESTART_NCS_CONFIRM_MISMATCH;
        case 'ack_timeout':
          return MetricName.SOCKET_RESTART_NCS_ACK_TIMEOUT;
        case 'lazy_sync_timeout':
          return MetricName.SOCKET_RESTART_NCS_LAZY_SYNC_TIMEOUT;
        case 'backend_agent_operation_timeout':
          return MetricName.SOCKET_RESTART_NCS_BACKEND_AGENT_OPERATION_TIMEOUT;
      }
    }

    switch (reason) {
      case 'dropped_update':
        return MetricName.SOCKET_RESTART_CF_DROPPED_UPDATE;
      case 'backend_agent_operation_timeout':
        return MetricName.SOCKET_RESTART_CF_BACKEND_AGENT_OPERATION_TIMEOUT;
      case 'confirm_mismatch':
      case 'ack_timeout':
      case 'lazy_sync_timeout':
        throw new Error(`${reason} should not be recorded for CF`);
    }
  })();

  ReliabilityMetrics.getInstance().success(metricName);
}
